(function () {
  angular.module('MktzapApp.Directives')
    .service('ValidateService', ValidateService)

  ValidateService.inject = [ 'ChannelManager' ]
  function ValidateService (ChannelManager) {
    this.IP_CODES = Object.freeze({
      EMPTY_FIELD: 1,
      INVALID_IP: 2,
      ALREADY_EXISTS: 3,
      REGISTER_SUCCESS: 4
    })

    this.validateIpWhitelist = function (ips, ip) {
      var ipExists = false
      if (ip.length) {
        if (ip.match(/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/) && ip != '0.0.0.0' && ip != '255.255.255.255') {
          angular.forEach(ips, function (value, key) {
            if (value == ip) {
              ipExists = true
            }
          })
          if (ipExists) {
            return this.IP_CODES.ALREADY_EXISTS
          }
          return this.IP_CODES.REGISTER_SUCCESS
        } else {
          return this.IP_CODES.INVALID_IP
        }
      } else {
        return this.IP_CODES.EMPTY_FIELD
      }
    }
  }
})();
